import FilledAptitudeTestSection from 'src/entities/FilledAptitudeTestSection';

export default class FilledAptitudeTest {
  id?: number;
  testId: number;
  passed?: boolean;
  sections?: Array<FilledAptitudeTestSection>;

  constructor(entity: FilledAptitudeTest) {
    this.id = entity.id || undefined;
    this.testId = entity.testId;
    this.passed = entity.passed || undefined;
    this.sections = entity.sections ?
      entity.sections.map(section => new FilledAptitudeTestSection(section)) : [];
  }
}


// WEBPACK FOOTER //
// ./src/entities/FilledAptitudeTest.tsx